export default {
      id: "search-usage",
      viewBox: "0 0 23.2 23.2",
      url: __webpack_public_path__ + "svg/sprite.svg#search",
      toString: function () {
        return this.url;
      }
    }